import { ChevronRight } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/shadcn/collapsible";

export const ReplySteps = ({ steps }: { steps?: string[] }) => {
  if (!steps || steps.length === 0) return null;

  return (
    <Collapsible className="group/steps mt-2">
      <CollapsibleTrigger className="inline-flex items-center gap-1 rounded-md px-1 py-0.5 text-xs text-slate-500 hover:text-slate-800 focus-visible:outline-2 focus-visible:outline-slate-400">
        <ChevronRight className="size-3 transition-transform group-data-[state=open]/steps:rotate-90" aria-hidden="true" />
        Show steps ({steps.length})
      </CollapsibleTrigger>
      <CollapsibleContent>
        <ul className="mt-1 list-disc space-y-0.5 pl-8 text-xs text-slate-500">
          {steps.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ul>
      </CollapsibleContent>
    </Collapsible>
  );
};
